import React, { useState } from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import { Avatar, ReviewRating, UserDisplayName } from '../../components';

import css from './Reviews.module.css';

const Review = props => {
  const { review, intl } = props;

  const [showMore, setShowMore] = useState(false);

  const onToggleShowMore = () => {
    setShowMore(prev => !prev);
  };
  const content = review.attributes.content;
  const shouldShowButton = content.length > 40;

  const date = review.attributes.createdAt;
  const dateString = intl.formatDate(date, { month: 'long', year: 'numeric' });

  const showMoreText = intl.formatMessage({ id: "Reviews.showMore" });
  const showLessText = intl.formatMessage({ id: "Reviews.showLess" });


  return (
    <div className={css.review}>
      <div className={css.userContainer}>
        <Avatar className={css.avatar} user={review.author} />
        <div className={css.infoContainer}>
          <div className={css.nameDateContainer}>
            <UserDisplayName className={css.username} user={review.author} intl={intl} />
            <span className={css.date}>{dateString}</span>
          </div>

          <div className={css.reviewRatingContainer}>
          <span className={css.desktopReviewRatingWrapper}>
            <ReviewRating
              rating={review.attributes.rating}
              className={css.desktopReviewRating}
              reviewStarClassName={css.reviewRatingStar}
            />
          </span>
          <ReviewRating
            rating={review.attributes.rating}
            className={css.mobileReviewRating}
            reviewStarClassName={css.reviewRatingStar}
          />
          <span className={css.ratingNumber}>{review.attributes.rating}/5</span>
          </div>

        </div>

        <p className={css.reviewInfo}></p>
      </div>
      <p className={classNames(css.reviewContent, { [css.showMore]: showMore })}>{content}</p>

      {shouldShowButton && (
        <button onClick={onToggleShowMore} className={css.showMoreButton}>
          {showMore ? showLessText : showMoreText}
        </button>
      )}
    </div>
  );
};

/**
 * A component that renders a list of reviews.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {Array<propTypes.review>} props.reviews - The reviews to render
 * @returns {JSX.Element}
 */
const Reviews = props => {
  const intl = useIntl();
  const { className, rootClassName, reviews = [] } = props;
  const classes = classNames(rootClassName || css.root, className);

  return reviews.length ? (
    <ul className={classes}>
      {reviews.map(r => {
        return (
          <li key={`Review_${r.id.uuid}`} className={css.reviewItem}>
            <Review review={r} intl={intl} />
          </li>
        );
      })}
    </ul>
  ) : null;
};

export default Reviews;
